import {
  FieldDependencyProperty,
  FieldOperator,
  Section,
  Field,
  ControlType,
} from "@cotecna/dynamic-view-engine";

export const EVENT_FIELDS: Field[] = [
  {
    id: "startDate",
    type: ControlType.DateTimePicker,
    label: "Start Date & Time",
    order: 1,
    propertyName: "startDate",
    value: null,
    required: true,
    visible: true,
    valid: false,
  },
  {
    id: "sameStartAndEndDate",
    type: ControlType.SlideToggle,
    label: "Same Start / End Date & Time",
    order: 2,
    propertyName: "sameStartAndEndDate",
    value: false,
    readableValue: "",
    required: false,
    visible: true,
    valid: true,
  },
  {
    id: "endDate",
    type: ControlType.DateTimePicker,
    label: "End Date & Time",
    order: 3,
    propertyName: "endDate",
    value: null,
    required: false,
    visible: true,
    valid: true,
  },
  {
    id: "option",
    type: ControlType.Dropdown,
    label: "Event",
    order: 4,
    propertyName: "option",
    value: "",
    readableValue: "",
    required: true,
    visible: true,
    valid: false,
  },
  {
    id: "item",
    type: ControlType.Dropdown,
    label: "Item",
    order: 6,
    propertyName: "item",
    value: "",
    readableValue: "",
    required: false,
    visible: true,
    valid: true,
  },
  {
    id: "printInReport",
    type: ControlType.SlideToggle,
    label: "Print in Report",
    order: 7,
    propertyName: "printInReport",
    value: false,
    readableValue: "",
    required: false,
    visible: true,
    valid: true,
  },
  {
    id: "name",
    type: ControlType.Input,
    label: "Name",
    order: 5,
    propertyName: "name",
    value: "",
    required: true,
    visible: false,
    valid: false,
  },
  {
    id: "remarks",
    type: ControlType.TextArea,
    label: "Remarks",
    order: 8,
    propertyName: "remarks",
    value: "",
    required: false,
    visible: true,
    valid: true,
  },
];

export const EVENT_SECTIONS: Section[] = [
  {
    id: "1",
    name: "",
    order: 1,
    isFixed: true,
    fields: EVENT_FIELDS,
    actions: [],
  },
];

export const EVENT_CONTROLS: any[] = [
  {
    id: "startDate",
  },
  {
    id: "sameStartAndEndDate",
  },
  {
    id: "endDate",
    dependencies: [
      {
        fieldId: "sameStartAndEndDate",
        trigger: {
          property: FieldDependencyProperty.value,
          operator: FieldOperator.equals,
          value: true,
          actions: [
            {
              property: FieldDependencyProperty.readonly,
              value: true,
            },
          ],
        },
      },
    ],
  },
  {
    id: "option",
    options: [],
  },
  {
    id: "item",
    options: [],
  },
  {
    id: "printInReport",
  },
  {
    id: "name",
    maxLength: 100,
    dependencies: [
      {
        fieldId: "option",
        trigger: {
          property: FieldDependencyProperty.value,
          operator: FieldOperator.equals,
          value: "ca59fba4-7370-4e0f-88a3-72711529e97b",
          actions: [
            {
              property: FieldDependencyProperty.required,
              value: true,
            },
            {
              property: FieldDependencyProperty.visible,
              value: true,
            },
          ],
        },
      },
      {
        fieldId: "option",
        trigger: {
          property: FieldDependencyProperty.value,
          operator: FieldOperator.differentThan,
          value: "ca59fba4-7370-4e0f-88a3-72711529e97b",
          actions: [
            {
              property: FieldDependencyProperty.value,
              value: "",
            },
          ],
        },
      },
    ],
  },
  {
    id: "remarks",
    maxLength: 500,
  },
];
